// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3tzE5","dragIcon":"Choice_dragIcon__hpuZb","left":"Choice_left__1kyoK","input":"Choice_input__2XMsm"};